import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'
import type { UserFilters } from '@/api/typings/user.typing'
import type { User } from '../transactions/get-transaction-details.action'

export function getUsersAction(filters: UserFilters = {}): Promise<ApiPaginationResponse<User[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/users?${params.toString()}`
  return api.get<ApiPaginationResponse<User[]>>(url)
}
